import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../../redux/actions/UsersActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import SettingsMenu from '../SettingsMenu';
import UsersTable from './UsersTable';
import UserSettingsModal from './UserSettingsModal';
import { PermissionTypes } from '../../../lib/systemVariables';

class UserSettingsPage extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModals: {
        userDetailsModal: false
      },
      editUserId: ''
    };
  }

  viewUserDetails(userId) {
    this.setState({ editUserId: userId }, this.toggleModal.bind(this, 'userDetailsModal'));
  }

  reloadUsers() { 
    this.props.actions.getUsers(this.props.usersTable.page, this.props.usersTable.resultsView, this.props.usersTable.sort);
  }

  async toggleUserActive(userId, active, replacementApproverId) {
    await this.props.actions.updateUserDetail(userId, { active }, replacementApproverId);
  }

  render() {
    return (
      <div className="page">
        <div className="subheader">
          <div className="container flex-justify flex-center">
            <SettingsMenu />
            <button className="btn btn-small btn-primary icon-left" onClick={this.toggleModal.bind(this, "userDetailsModal")}>New User</button>
          </div>
        </div>
        <UsersTable
          {...this.props.usersTable}
          updateTable={this.props.actions.updateTable}
          getUsers={this.props.actions.getUsers}
          viewUserDetails={this.viewUserDetails.bind(this)}
          toggleUserActive={this.toggleUserActive.bind(this)}
          updatingActive={this.props.updateUserDetail} 
          approvers={this.props.approvers.data}/>

        <UserSettingsModal
          show={this.state.showModals.userDetailsModal}
          close={() => {
            if (this.state.editUserId) {
              this.setState({ editUserId: '' });
            }
            this.props.actions.clearUserDetailsAndPermissions();
            this.toggleModal("userDetailsModal");
          }}

          editUserId={this.state.editUserId}

          getUserDetails={this.props.actions.getUserDetails}
          getUserPermissions={this.props.actions.getUserPermissions}
          userDetails={this.props.userDetails}
          userPermissions={this.props.userPermissions}

          approvers={this.props.approvers.data}
          departments={this.props.departments}
          roles={this.props.roles}
          permissionTypes={this.props.permissionTypes}
          israelFunds={this.props.israelFunds}
          usFunds={this.props.usFunds}
          allowAllFundsAccess={
            this.props.thisUserProfile.departments.length === this.props.departments.length
            && this.props.thisUserPermissions.indexOf(PermissionTypes.AllFundsAccess) >= 0
          }

          getPermissionsForRole={this.props.actions.getPermissionsForRole}
          permissionsForRole={this.props.permissionsForRole}

          createUser={this.props.actions.createUser}
          updateUser={this.props.actions.updateUser}
          creatingUser={this.props.createUser}
          updatingUser={this.props.updateUser}

          reloadUsers={this.reloadUsers.bind(this)} />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...state.users,
    usersTable: state.usersTable,
    departments: state.settings.systemSettings.data.otherSettings.departments,
    permissionTypes: state.settings.systemSettings.data.otherSettings.permissionTypes,
    roles: state.settings.systemSettings.data.otherSettings.roles,
    israelFunds: state.funds.fundsByDept.IL,
    usFunds: state.funds.fundsByDept.US,

    thisUserProfile: state.userProfile.profile.data,
    thisUserPermissions: state.userProfile.permissions.data
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(usersActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSettingsPage);


// WEBPACK FOOTER //
// ./src/components/settingComponents/userSettings/UserSettingsPage.jsx